import { render, staticRenderFns } from "./ExerciseDetailsForm.vue?vue&type=template&id=f88cf5e6&scoped=true&"
import script from "./ExerciseDetailsForm.vue?vue&type=script&lang=js&"
export * from "./ExerciseDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseDetailsForm.vue?vue&type=style&index=0&id=f88cf5e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88cf5e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VCol,VRow,VSheet,VTextField,VTextarea})
